<!-- eslint-disable -->
<template lang="pug">
    register-school-form(:school='school', :submit='create')
        template(slot='title') {{ $i18n.t('school.school_create_title') }}
        template(slot='button') {{ $i18n.t('school.school_create_button') }}
</template>

<script>
    /*eslint-disable*/
    import RegisterSchoolForm from './RegisterSchoolForm.vue';
    import SchoolApi from '../../api/school'
    export default {
        props: {
            adminInfo: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                school: {
                    name: '',
                    status: 'active',
                    email: '',
                    phone: '',
                    courses: [],
                    admins: [],
                    mainContact: null,
                    account: {
                        paymentService: null,
                    },
                    locations: [
                        {
                            city: '',
                            address: '',
                            isMain: true
                        }
                    ],
                    isMapAvailable: true,
                    studentPayed: undefined,
                    isBillingActive: true,
                    isTeachersBillingActive: true,
                }
            }
        },
        components: {
            RegisterSchoolForm
        },
        created() {
            if (this.adminInfo) {
                this.school.mainContact = this.adminInfo
                this.school.admins = [this.adminInfo]
            } else {
                this.$router.push({ name: 'without-active-schools' });
            }
        },
        methods: {
            create(school) {
                return SchoolApi.registerSchool(school)
                .then((data) => {
                    this.$router.push({name: 'school:profile', params: {id: data.id, withOpenedBalanceModal: false}});
                })
            }
        }
    }
</script>
